module.exports = __webpack_public_path__ + "img/bbc_news.936b8ba2.png";